import { useEffect, useState } from "react";
import { RotateCw, WifiOff } from "lucide-react";
import { connection, onConnection } from "@/lib/connection";

/** A quiet line across the top when the connection goes, instead of a dead session. */
export const ConnectionBanner = ({ pending, onRetry, accent = "#C87D55" }) => {
  const [c, setC] = useState(connection());
  useEffect(() => onConnection(setC), []);

  const down = !c.online || c.dropped;
  if (!down && !pending) return null;

  return (
    <div
      data-testid="connection-banner"
      className="fixed inset-x-0 top-0 z-[60] flex flex-wrap items-center justify-center gap-x-4 gap-y-1 px-5 py-2.5 text-center backdrop-blur-xl"
      style={{ background: "rgba(12,12,11,0.88)", borderBottom: `1px solid ${accent}44` }}
    >
      <WifiOff size={13} style={{ color: accent }} />
      <p className="text-[13px]" style={{ color: "var(--text-dim)" }}>
        {pending
          ? "I didn't catch that — the line dropped. I'll send it again the moment we're back."
          : "The line is quiet. Everything you've said is still here."}
      </p>
      {pending && (
        <button
          data-testid="connection-retry-btn"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] transition-colors hover:text-[#F4EFE6]"
          style={{ borderColor: `${accent}55`, color: accent }}
        >
          <RotateCw size={11} /> try again
        </button>
      )}
    </div>
  );
};
